import XLSX from "xlsx";
import { selectMapping } from "./DataProcessing";
import Attachment from "./Attachment";

const FileProcessor = async ({
  file,
  kind,
  ndcList,
  accessibleEntityIds = [],
  fieldMappings,
  salt,
  selectedMapping = null,
  data = null,
  onProgress = null,
  fileId = null,
}) => {
  if (data) {
    const mapping = selectedMapping || selectMapping(fieldMappings, data);

    const attachment = new Attachment({
      filename: file.name,
      kind,
      data,
      mapping,
      ndcList,
      accessibleEntityIds,
      fileId,
    });

    await attachment.processData(salt, onProgress);
    return attachment;
  }

  const rABS = !!new FileReader().readAsBinaryString;

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const bstr = e.target.result;

        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];

        const parsedData = XLSX.utils.sheet_to_json(ws, {
          raw: false,
          blankrows: false,
          defval: "",
        });

        const mapping = selectedMapping || selectMapping(fieldMappings, parsedData);

        const attachment = new Attachment({
          filename: file.name,
          kind,
          data: parsedData,
          mapping,
          ndcList,
          accessibleEntityIds,
          fileId,
        });

        await attachment.processData(salt, onProgress);
        resolve(attachment);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => reject(reader.error || new Error(`Failed to read file: ${file.name}`));

    if (rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  });
};

export default FileProcessor;
